
import Hero from './components/Hero';
import Features from './components/Features';
import Pricing from './components/Pricing';
import Testimonials from './components/Testimonials';
import Policy from './components/Policy';
import Footer from './components/Footer';

export default function Home() {
  return (
    <div className="min-h-screen bg-white">
      {/* Main content */}
      <main>
        <Hero />
        <Features />
        {/* 가격 정보 */}
        <Pricing />
        {/* 후기 */}
        <Testimonials />
        {/* 운영 정책 */}
        <Policy />
      </main>
      {/* 푸터 */}
      <Footer />
    </div>
  );
}
